import { Tabs } from 'antd';
import React from 'react';
import { CONFIG_TAG_TABS } from '../../../../../common/constants';

const TAB_ENTRIES = [
  CONFIG_TAG_TABS?.USERS,
  CONFIG_TAG_TABS?.ORDERS,
  CONFIG_TAG_TABS?.REVIEW,
  CONFIG_TAG_TABS?.INVENTORY,
];

/**
 * Card-style tabs for the Config Tags screen (same structure as `AllTabs` / `NewTabs` in orders).
 * Table content must live inside the active tab pane so `.card-container` tab styles (height, padding,
 * scroll) apply; rendering content as a sibling below `Tabs` leaves an empty tab body filling the
 * viewport and hides the table.
 */
const ConfigTagsTabs = ({ activeKey, onChange, children }) => {
  const items = TAB_ENTRIES.map((tab) => ({
    key: tab.key,
    label: tab.label,
    children: activeKey === tab.key ? children : null,
  }));

  return (
    <div className="card-container">
      <Tabs
        activeKey={activeKey}
        type="card"
        className="full-width"
        onChange={onChange}
        items={items}
        destroyInactiveTabPane
      />
    </div>
  );
};

export default ConfigTagsTabs;
